import { render, staticRenderFns } from "./SectionTwo.vue?vue&type=template&id=6135e7a5&scoped=true&"
import script from "./SectionTwo.vue?vue&type=script&lang=js&"
export * from "./SectionTwo.vue?vue&type=script&lang=js&"
import style0 from "./SectionTwo.vue?vue&type=style&index=0&id=6135e7a5&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6135e7a5",
  null
  
)

export default component.exports